import React from 'react'

const InvoiceIcon = () => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" viewBox="0 0 12 15" fill="none">
<path d="M8.00033 0.666992H2.00033C1.6467 0.666992 1.30756 0.807468 1.05752 1.05752C0.807468 1.30756 0.666992 1.6467 0.666992 2.00033V12.667C0.666992 13.0206 0.807468 13.3598 1.05752 13.6098C1.30756 13.8598 1.6467 14.0003 2.00033 14.0003H10.0003C10.3539 14.0003 10.6931 13.8598 10.9431 13.6098C11.1932 13.3598 11.3337 13.0206 11.3337 12.667V4.00033L8.00033 0.666992Z" stroke="#616161" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  )
}

export default InvoiceIcon